// @flow

import type { AuthenticationClientInterface } from './authentication-client-interface'
import { LoginResult } from '../../types/login-result'
import Cookies from 'js-cookie'
const jwt = require('jsonwebtoken')

class MockAuthenticationClient implements AuthenticationClientInterface {
  baseUrl: string

  constructor (baseUrl: string) {
    this.baseUrl = baseUrl
  }

  /**
   * @param username can specify an idm identifier to encode in returned jwt token, for example: "7919@sqills.com"
   * @param password use JWT secret encryption key
   * @returns {Promise<LoginResult>}
   */
  async login (username: string, password: string): Promise<LoginResult> {
    const identifierMatches = username.match(/^([0-9]+)@.+$/)
    let identifier = 8114
    if (identifierMatches) {
      identifier = identifierMatches[1]
    }
    const token = jwt.sign({
      roles: ['ROLE_USER'],
      identifier
    }, password, { expiresIn: '60 minutes' })
    Cookies.set('refreshToken', token)
    return { token }
  }

  async forgotPassword (email: string, returnUrl: string): Promise<boolean> {
    return true
  }

  async verifyResetPasswordToken (token: string): Promise<boolean> {
    return true
  }

  async resetPassword (token: string, password: string): Promise<boolean> {
    return true
  }
}

export default MockAuthenticationClient



// WEBPACK FOOTER //
// ./src/services/authentication/mock-authentication-client.js